import { Form, Input, Button, message, Result, Row } from 'antd'
import { useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import handleFormError from 'utils/handleFormError'
import localStorage from 'utils/localStorage'
import ForgetPasswordEmail from 'api/auth/forgetPassword'
import VerifyOTP from 'api/auth/verifyOtp'
import ResetPassword from 'api/auth/resetPassword'

interface ValueTypes {
	email: string
}
interface OtpValueTypes {
	otp: string
}
interface ResetValueTypes {
	password: string
}
const ForgetPasswordForm = () => {
	const [verifyEmail, setVerifyEmail] = useState(true)
	const [enterOTP, setEnterOTP] = useState(false)
	const [newPassword, setNewPassword] = useState(false)
	const [success, setSuccess] = useState(false)
	const [loading, setLoading] = useState(false)

	const handleVerifyEmail = async (values: ValueTypes) => {
		try {
			setLoading(true)
			await ForgetPasswordEmail(values)
			setLoading(false)
			setNewPassword(false)
			setVerifyEmail(false)
			setEnterOTP(true)
			setSuccess(false)
			message.success('OTP Successfully Sent')
		} catch (error) {
			setLoading(false)
		}
	}

	const handleVerifyOTP = async (values: OtpValueTypes) => {
		try {
			setLoading(true)
			await VerifyOTP(values)
			setLoading(false)
			setVerifyEmail(false)
			setEnterOTP(false)
			setNewPassword(true)
			message.success('OTP Verified You Can Reset Your Password ')
		} catch (error) {
			setLoading(false)
		}
	}

	const handleResetPassword = async (values: ResetValueTypes) => {
		try {
			setLoading(true)
			await ResetPassword(values)
			setLoading(false)
			setEnterOTP(false)
			setNewPassword(false)
			setVerifyEmail(false)
			setSuccess(true)
			localStorage.clear()
			message.success('Password Reset Successfully Please Login')
		} catch (error) {
			setLoading(false)
		}
	}

	const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
		handleFormError(errorInfo)
	}

	return (
		<>
			{/* email for send otp form */}

			{verifyEmail === true && (
				<Form
					name='basic'
					initialValues={{
						email: '',
					}}
					onFinish={handleVerifyEmail}
					onFinishFailed={onFinishFailed}
					layout='vertical'
					autoComplete='off'
				>
					<Form.Item
						label='Email'
						name='email'
						rules={[
							{
								required: true,
								message: 'Email is required',
							},
							{
								pattern:
									/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
								message: 'Please enter a valid Email',
							},
						]}
					>
						<Input />
					</Form.Item>

					<Form.Item>
						<Button type='primary' htmlType='submit' block loading={loading}>
							Verify Email
						</Button>
					</Form.Item>
				</Form>
			)}

			{/* Verify OTP Form */}

			{enterOTP === true && (
				<Form
					name='basic'
					initialValues={{
						otp: '',
					}}
					onFinish={handleVerifyOTP}
					onFinishFailed={onFinishFailed}
					layout='vertical'
					autoComplete='off'
				>
					<Form.Item
						label='OTP'
						name='otp'
						rules={[
							{
								required: true,
								message: 'OTP is required',
							},
						]}
					>
						<Input />
					</Form.Item>

					<Form.Item>
						<Button type='primary' htmlType='submit' block loading={loading}>
							Verify OTP
						</Button>
					</Form.Item>
				</Form>
			)}

			{/* Reset Password form */}
			{newPassword === true && (
				<Form
					name='basic'
					initialValues={{
						password: '',
						confirmPassword: '',
					}}
					onFinish={handleResetPassword}
					onFinishFailed={onFinishFailed}
					layout='vertical'
					autoComplete='off'
				>
					<Form.Item
						label='New Password'
						name='password'
						rules={[
							{
								required: true,
								message: 'Password is required',
							},
							{
								pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&^_-]{6,32}$/,
								message:
									' Password Should have at least 1 alphabet, 1 digit, 1 special characters e.g. @$!%*#?&^_- , with no space and should Minimum 6 characters long',
							},
						]}
					>
						<Input.Password />
					</Form.Item>

					<Form.Item
						label='Confirm Password'
						name='confirmPassword'
						dependencies={['password']}
						rules={[
							{
								required: true,
								message: 'Please Re-Enter your Password to confirm',
							},
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue('password') === value) {
										return Promise.resolve()
									}
									return Promise.reject(
										new Error('The two passwords that you entered do not match!')
									)
								},
							}),
						]}
					>
						<Input.Password />
					</Form.Item>

					<Form.Item>
						<Button type='primary' htmlType='submit' block loading={loading}>
							Reset Password
						</Button>
					</Form.Item>
				</Form>
			)}
			{success === true && (
				<Row justify='center' align='middle'>
					<Result
						status='success'
						title='Password Changed!'
						subTitle='Your password has been changed successfully. Use your new password to login'
					/>
					,
				</Row>
			)}
		</>
	)
}

export default ForgetPasswordForm
